import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "namePlaceholder"]
  static classes = ["gradient"]

  static values = {
    title: String,
    name: String
  }

  connect() {
    if (this.hasNameInputTarget) {
      this.#setName()
    }

    if (this.hasNamePlaceholderTarget) {
      const userName = this.#getName()
      if (userName) {
        this.namePlaceholderTarget.innerHTML = this.nameValue.replace(
          `%{name}`,
          `<span class="fs-4">${this.#escapeHtml(userName)}</span>`
        )
        this.element.classList.add(this.gradientClass)
      } else {
        this.namePlaceholderTarget.innerHTML = this.titleValue
      }
    }
  }

  #escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  #setName() {
    localStorage.setItem("name", this.nameInputTarget.value)
  }

  #getName() {
    return localStorage.getItem("name")
  }
}
